// extracted by mini-css-extract-plugin
export default {"activitiesList":"Activities_activitiesList__3pZxW"};